module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo22-cdc886691aef8803b9824e7e8081cdf4.jpg";